import { Mesh } from "three";
export class Hitbox extends Mesh {
    //ottimizzare facendo ricalcolare le matrici da un controller esterno per evitare un botto di ricalcoli (usare var booleana)
    _parent; //separato perchè non è stato davvero aggiunto al parent
    updateMatrix() {
        super.updateMatrix();
        this.updateWithParentMatrix();
    }
    ;
    updateWithParentMatrix = () => {
        this._parent?.updateMatrixWorld(true);
        this.matrixWorld.multiplyMatrices(this._parent.matrixWorld, this.matrix);
    };
    constructor(geometry) {
        super(geometry);
    }
    attachTo(parent, position) {
        if (!this._parent) {
            position && this.position.copy(position);
            this._parent = parent;
            parent.bindEvent(["onPositionComponentChange", "onRotationComponentChange", "onScaleComponentChange"], this.updateWithParentMatrix); //creare evento collegato ad update delle matrici del parent per ottimizzare?
            this.updateMatrix();
        }
        else {
            console.warn("cannot attach hitbox to a new parent");
        }
    }
    dispose() {
        super.dispose && super.dispose();
        this._parent?.unbindEvent(["onPositionComponentChange", "onRotationComponentChange", "onScaleComponentChange"], this.updateWithParentMatrix);
    }
}
//# sourceMappingURL=Hitbox.js.map